import { applyRateModeToValues } from "./rateMode";

export function buildInitialValues({
  isManual,
  isTransfer,
  selectedAccount,
  now,
}) {
  if (isManual) {
    return {
      senderBankAccountId: undefined,
      receiverBankAccountId: selectedAccount?.id || undefined,
      transactionDate: now,
      amount: null,
      sharedRate: undefined,
      senderRate: undefined,
      receiverRate: undefined,
      fee: 0,
      description: "",
    };
  }

  if (isTransfer) {
    return {
      transferScope: "INTERNAL",
      externalInstitutionId: undefined,
      senderBankAccountId: selectedAccount?.id || undefined,
      receiverCurrencyFilter: "ALL",
      receiverBankAccountId: undefined,
      transactionDate: now,
      amount: null,
      sharedRate: undefined,
      senderRate: undefined,
      receiverRate: undefined,
      fee: 0,
      description: "",
    };
  }

  return {};
}

export function resetRateFields() {
  return {
    receiverBankAccountId: undefined,
    sharedRate: undefined,
    senderRate: undefined,
    receiverRate: undefined,
  };
}

export function buildSubmitPayload({
  values,
  rateMode,
  transactionDateFormat = "YYYY-MM-DDTHH:mm:ss",
}) {
  const normalized = applyRateModeToValues(rateMode, values);

  const {
    receiverCurrencyFilter: _receiverCurrencyFilter,
    transferScope: _transferScope,
    sharedRate: _sharedRate,
    ...rest
  } = normalized;

  return {
    ...rest,
    transactionDate: normalized.transactionDate
      ? normalized.transactionDate.format(transactionDateFormat)
      : null,
  };
}